import { Box, styled, TableContainer } from '@mui/material';

export const CouponsTableContainer = styled(Box)(() => ({
  marginTop: '72px',
}));

export const PaymentsTableContainer = styled(TableContainer)(() => ({
  marginTop: '48px',
}));
